import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, concatMap, shareReplay, tap, finalize } from 'rxjs/operators';
import { Filters } from 'src/app/models/filters.model';
import { EventsService } from 'src/app/services/events.service';
import { SearcherService } from 'src/app/services/searcher.service';
import { Environment } from 'src/environments/environment';

@Component({
  selector: 'page-full-screen-embeddings',
  templateUrl: 'full-screen-embeddings.html',
  styleUrls: ['./full-screen-embeddings.page.scss'],
  standalone: false
})
export class FullScreenEmbeddingsPage {
  public itemType: string = 'embedded';
  public filters$: BehaviorSubject<Filters> = new BehaviorSubject({
    searchKey: '',
    start: 0,
    length: 20
  });

  public pageId: number;
  public page$: Observable<any>;
  /** Keeps toolbar + item-searcher mounted on back navigation until page$ emits again */
  public latestPage: any = null;
  public forbidden: boolean = false;
  public listLoading = true;
  public readonly listSkeletonPlaceholders = [1, 2, 3];

  constructor(
    private route: ActivatedRoute,
    private searcherService: SearcherService,
    private events: EventsService
  ) {}

  ionViewWillEnter() {
    this.listLoading = true;

    const nextPageId = +this.route.snapshot.paramMap.get('id');
    if (this.pageId !== undefined && nextPageId !== this.pageId) {
      this.latestPage = null;
    }
    this.pageId = nextPageId;

    this.page$ = this.filters$.pipe(
      concatMap((filters) =>
        this.searcherService
          .allItems(
            `${Environment.API_BASE_URL_V2}/api/empatica/v1/components/embedded/${this.pageId}/elements`,
            filters,
            this.itemType
          )
          .pipe(finalize(() => (this.listLoading = false)))
      ),
      tap((response) => {
        this.latestPage = response;
      }),
      tap((response) => this.events.pages$$.next(response.title)),
      tap(() => (this.forbidden = false)),
      catchError((err: any) => {
        if (err.status === 403) {
          this.forbidden = true;
        }

        throw err;
      }),
      shareReplay()
    );

    this.getAllItems({ filters: { ...this.filters$.value, start: 0 } });
  }

  public getAllItems({ filters }) {
    this.filters$.next(filters);
  }
}
